class FeedCalc extends HTMLElement {
    constructor() {
      super();

      this.onButtonClick();
      this.productCard = "";
      this.productId = "";
      this.productTitle = "";
      this.productCalories = null;

      // Only show products that have a valid value in metafield calories per gram
      this.productsRaw = JSON.parse(document.querySelector('#products-for-feed-calc-search').innerHTML);
      this.products = this.productsRaw.filter(p => p.metafield !== "0");
    }

    // calculation button
    onButtonClick(){ 
      this.addEventListener("click", function(event){
        if(event.target.closest('[type="button"]')) {
          this.calculation();
        }
      })
    }
 
    connectedCallback() {
      const observer = new MutationObserver(() => {

        // init input value & range elements
        const initValue  = (rangeSelector, valueSelector, numb) => {
          const rangeElement = this.querySelector(rangeSelector);
          const valueElement = this.querySelector(valueSelector);
          const localStorageVal = window.localStorage.getItem(valueSelector);
          if(rangeElement) {
            rangeElement.value = localStorageVal ? localStorageVal : numb;
          }
          if(valueElement){
            valueElement.value = localStorageVal ? localStorageVal : numb;
          }
        }
        initValue('#weightRange', '#weightValue', 35);
        initValue('#ageRange', '#ageValue', 10);
        initValue('#activityRange', '#activityValue', 50);

        // update input value & range elements on change
        const updateValue = (rangeSelector, valueSelector, num) => {
          const rangeElement = this.querySelector(rangeSelector);
          const valueElement = this.querySelector(valueSelector);

          if (rangeElement && valueElement) {
            rangeElement.addEventListener('input', (event) => {
              window.localStorage.setItem(valueSelector, event.target.value);
              valueElement.value = window.localStorage.getItem(valueSelector);
            });
            valueElement.addEventListener('input', (event) => {
              window.localStorage.setItem(valueSelector, event.target.value);
              rangeElement.value = window.localStorage.getItem(valueSelector);
            });
          }
          if(!valueElement && rangeElement) {
            rangeElement.addEventListener('input', (event) => {
              window.localStorage.setItem(valueSelector, event.target.value);
              rangeElement.value = window.localStorage.getItem(valueSelector);
            });
          }
        };
        updateValue('#weightRange', '#weightValue');
        updateValue('#ageRange', '#ageValue');
        updateValue('#activityRange', '#activityValue');


        const questionLocal = window.localStorage.getItem("input[name='castration']");
        if(questionLocal) {
          const questionStatus = this.querySelectorAll("input[name='castration']");
          questionStatus.forEach((question) => {
            question.checked = question.value === questionLocal;
          });
        }

        // check if product is chosen to enable button
        const productCardObserver = new MutationObserver(() => {
          this.productCard = targetNode;
          const checkedQuestions =Array.from(this.querySelectorAll("input[name='castration']")).filter(q => q.checked);
          if(this.productCard) {
            buttonValidation(checkedQuestions, this.productCard);
          }
        });
        const targetNode = document.querySelector("#feed-calc-product-card");
        const config = { childList: true, subtree: true };
        productCardObserver.observe(targetNode, config);

        const checkButton =(key) => {
          const questionStatus = this.querySelectorAll(key);

          // protect that only one checkbox is checked, two checked shouldn't be possible
          questionStatus.forEach((question) => {
            question.addEventListener('change', (event) => {
              questionStatus.forEach((q) => {
                if (q !== event.target) {
                  q.checked = false;
                }
              });
              const checkedQuestions = Array.from(questionStatus).filter(q => q.checked);
              const productCard = document.querySelector("#feed-calc-product-card .product-card");

              if(checkedQuestions.length === 0) {
                window.localStorage.removeItem(key);
              } else {
                window.localStorage.setItem(key, event.target.value);
              }
              if(checkedQuestions && productCard)
                buttonValidation(checkedQuestions, productCard);
            });
          });
        }
        checkButton("input[name='castration']", this.querySelector(".btn"));

        // check if castration question is valid & product is chosen to enable calculation button
        const buttonValidation = (checkedQuestions, productCard) => {
          let button = this.querySelector(".btn");
          if (checkedQuestions.length === 1 && productCard) {
            button.disabled = false;
            button.setAttribute('aria-disabled', false);

            this.productId = document.querySelector("#feed-calc-product-card .product-card").getAttribute("data-product-id");
            if(this.productId) {
              const product = this.products.find(product => product.id == this.productId);
              this.productCalories = product.metafield;
              this.productTitle = product.title;
            }
          } else {
            button.disabled = true;
            button.setAttribute('aria-disabled', true);
          }
        }

      });
    
      observer.observe(this, { childList: true, subtree: true });
    }

    // calculate results
    calculation() {
      this.age = this.querySelector('#ageValue')?.value;
      this.activity = this.querySelector('#activityRange')?.value;
      const weightFactor = this.querySelector('#weightValue')?.value ** 0.75;
      const castrationStatus = this.querySelector("input[name='castration']")?.checked == true ? -15 : 0;

      if(this.age && this.activity && weightFactor && this.productCalories) {
        const ageFactor = this.age < 7 ? 95 : this.age < 12 ? 85 : 80;
        const activityFactor = this.activity * (35 / 100) - 15;
        const calories = Math.round(weightFactor * (ageFactor + activityFactor + castrationStatus));
        const gramms = Math.round(calories / this.productCalories);
        const recomCaloriesElement = this.querySelector('#recomCalories');
        if (recomCaloriesElement) {
          recomCaloriesElement.innerHTML = calories + " kcal";
        }
        const recomGrammsElement = this.querySelector('#recomGramms');
        if(recomGrammsElement) {
          recomGrammsElement.innerHTML = gramms + " g";
        }
        const recomTitleElement = this.querySelector('#recomProductTitle');
        if(recomTitleElement) {
          recomTitleElement.innerHTML = this.productTitle;
        }
        this?.querySelector('#calculationResults')?.setAttribute('aria-disabled', false);
      }
    }
  };

customElements.define('feed-calc', FeedCalc);


class informationPopup extends HTMLElement{
  constructor(){
    super()
  }

  connectedCallback() {
    const observer = new MutationObserver(() => {

        this.setPopupSize = () => {
          const popupElement = this.querySelector(".information-popup--background");
          const windowWidth = window.innerWidth;

          if(windowWidth <= 992){
            let popupWidth = 400;
            if (windowWidth <= 600) {
              const vw = windowWidth / 100;
              popupWidth = 80 * vw;
            }
            const leftPosition = (windowWidth - popupWidth) / 2;
            popupElement.style.left = `${leftPosition}px`;
          } else {
            popupElement.style.left = `auto`;
            if(this.hasAttribute("open")){
              this.removeAttribute("open");
            }
          }
        }
      
      this.setPopupSize();

      window.addEventListener('resize', () => {
          this.setPopupSize();
      });

      this.closeBtn = document.querySelector(".feed-calc-product-search .information-popup-close-btn");
      this.closeBtn.addEventListener("click", (event)=> {
          this.close(event);
      })

      this.icon = document.querySelector(".feed-calc-product-search .information-popup-icon--wrapper");

      this.icon.addEventListener("mouseover", (event) => {
          this.open(event);
      })

      this.icon.addEventListener("click", (event) => {
        this.open(event);
      })

      this.icon.addEventListener("mouseleave", (event) => {
          this.close(event);
      })
      
      this.open = (event) =>{
        if (event.type == "click" || (event.type == "mouseover" && window.innerWidth > 992)) {
          this.setAttribute("open", "");
        }
      }
      
      this.addEventListener("click", (event) => {
        if(this.hasAttribute("open") && !event.target.closest(".feed-calc-product-search .information-popup--text, .information-popup-icon--wrapper")){
          this.removeAttribute("open");
        }
      });

      this.close = (event) => {
        if (event.type == "click" || (event.type == "mouseleave" && window.innerWidth > 992 && !this.has_clickable_element)) {
          this.removeAttribute("open");
        }

      }
    });

    observer.observe(this, { childList: true, subtree: true });
    }
  }
customElements.define('information-popup', informationPopup);
